import DB from './db'
import * as selectors from 'webmango-core/selectors'
import * as moreSelectors from 'webmango-core/selectors/selectors'
import * as Job from 'webmango-core/lib/job'
import parseXML from 'webmango-utils/xml'
import { clear } from 'idb-keyval'

let init = false

export default function devtools (store) {
  if (init) return
  init = true
  const _selectors = { ...moreSelectors, ...selectors }
  window.PouchDB = DB
  window.wm = {
    clearIDB: clear,
    store,
    _selectors,
    select: {},
    get state () {
      return store.getState()
    },
    get xml () {
      const state = store.getState()
      const name = state.schemas.mango
      const mango = state.mangoXML[name]
      return parseXML(mango && mango.value)
    },
    job () {
      const state = store.getState()
      const { processID } = state.current
      if (!processID) {
        return void console.error('not on a process')
      }
      return Job.create(state, processID)
    }
  }

  Object.keys(_selectors).forEach(key => {
    const selector = _selectors[key]
    if (typeof selector === 'function') {
      window.wm.select[key] = (...args) => selector(store.getState(), ...args)
    } else if (typeof selector === 'object') {
      const c = {}
      window.wm.select[key] = c
      Object.keys(selector).forEach(key => {
        if (typeof selector[key] === 'function') {
          c[key] = (...args) => selector[key](store.getState(), ...args)
        }
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/devtools.js